module.exports = __webpack_public_path__ + "static/media/DOPIBOJ_figure.1329f046.png";